<template>
  <div class="custom-container">
    <menu-nuevo v-if="logged && !routesWithoutMenu.includes(routeActive)" @openUserMenu="toggleUserMenu"/>
    <user-menu v-if="userMenuActive && logged" @closeUserMenu="toggleUserMenu" />
    <RouterView />
  </div>
  <Notifications />
</template>

<script>
import { computed, watch } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import Notifications from '@/components/Common/Notifications/Main.vue';
//import persistentData from "@/plugins/persistentData";
import MenuNuevo from './components/Common/MenuNuevo.vue';
import UserMenu from '@/components/Common/UserMenu.vue';
import { provide } from 'vue';

export default {
  components: {
    Notifications,
    MenuNuevo,
    UserMenu
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const logged = computed(() => store.getters.manageUser_logged);
    const organizationId = computed(() => store.getters.manageUser_organizationId);
    const userMenuActive = ref(false);
    provide('userMenuActive',userMenuActive);
    
    const routesWithoutMenu = ['AUTH_FROM_FORGE','JOVEN_PROFILE', 'JOVEN_DASHBOARD', 'TUTOR_DETAIL_DASHBOARD','TUTOR_DASHBOARD', 'COORDINATOR_DASHBOARD','ALLIANCE_DASHBOARD'];

    const routeActive = ref('');
    
    watch(() => route.name, (val) => { 
      routeActive.value = val
      if(routeActive.value != undefined && routeActive.value != "USER_REGISTRATION" && routeActive.value != "AUTH_FROM_FORGE"){
        store.dispatch('manageUser_active');
      } 
      })

    function toggleUserMenu(){
      userMenuActive.value = !userMenuActive.value;
    }

    return {
      logged,
      organizationId,
      routeActive,
      routesWithoutMenu,
      userMenuActive,
      toggleUserMenu,
    }
  }
}
</script>

<style lang="scss">
  @import "@/styles/main.scss";

  .custom-container {
    position: relative;
    min-height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    background: $lightergray;
  }
</style>